const development = {
  protocol: 'http',
  host: 'localhost',
  port: '8000',
  graphql: {
    path: 'graphql/',
    pathReports: '/reports/graphql',
    pathAdmin: '/admin/graphql',
  },
};

const production = development;

let config;

switch (process.env.NODE_ENV) {
  case 'production':
    config = production;
    break;

  default:
    config = development;
    break;
}

module.exports = config;
